import { openBlock as l, createElementBlock as o, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(s, e) {
  return l(), o("svg", n, [...e[0] || (e[0] = [
    t("path", {
      fill: "currentColor",
      d: "M8.4 17 7 15.6l3.6-3.6L7 8.425l1.4-1.4 3.6 3.6 3.575-3.6 1.4 1.4-3.6 3.575 3.6 3.6-1.4 1.4L12 13.4z"
    }, null, -1)
  ])]);
}
const d = { render: r };
export {
  d as default,
  r as render
};
